<template src="./ViewDocumentDetails.html"></template>

<script>
import { getDocumentById } from "../../../services/document";

export default {
  name: "ViewDocumentDetails",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      document: null,
      loading: true,
      error: null,
      breadcrumbs: [
        {
          text: "Documentos",
          disabled: false,
          to: { name: "Gestor Documental" },
        },
        {
          text: "",
          disabled: true,
        },
      ],
      attachmentsHeaders: [
        { text: "Archivo", value: "fileName" },
        { text: "Versión", value: "versionNumber" },
        { text: "Fecha de Reporte", value: "reportDate" },
        { text: "Autor", value: "reportedByUser" },
        { text: "Observaciones", value: "observation", sortable: false },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  watch: {
    document: {
      handler(newDoc) {
        if (newDoc && newDoc.name) {
          this.breadcrumbs[1].text = newDoc.name;
        }
      },
      immediate: true,
    },
  },
  async created() {
    await this.getDocumentDetails();
  },
  methods: {
    async getDocumentDetails() {
      const documentId = this.id;
      this.loading = true;
      this.error = null;
      try {
        const response = await getDocumentById(documentId);
        this.document = response.data;
      } catch (error) {
        console.error("Error fetching document details:", error);
        this.error = "No se pudo cargar el detalle del documento.";
        this.document = null;
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        if (
          typeof dateString === "string" &&
          /^\d{4}-\d{2}-\d{2}$/.test(dateString)
        ) {
          return dateString;
        }
        return "N/A";
      }
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("es-ES", options);
    },
    formatStatus(status) {
      switch (status) {
        case "ABOUT_TO_EXPIRE":
          return "Próximo a vencer";
        case "UPDATED":
          return "Actualizado";
        default:
          return status;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "ABOUT_TO_EXPIRE":
          return "#fc5b00";
        case "UPDATED":
          return "green";
        default:
          return "grey";
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "Gestor Documental" });
      }
    },
  },
};
</script>

<style lang="scss" src="./ViewDocumentDetails.scss" scoped></style>
